export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "legCalculate.worker.30bf4212d850e1badb0c-609.worker.js");
}
